import { useEffect, useState } from "react";
import { ArrowLeft, Bell, CheckCircle2, Download, LogIn, ShieldCheck, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";
import { BACKEND, api } from "../../connect/api";

const STEPS = [
  { img: "/nsconnect/guide/download.webp", icon: Download, title: "1 · Download the app", text: "On your Android phone open connect.nexsecure.in and tap “Get the Android app”. The file NexSecure-Connect.apk downloads in a few seconds." },
  { img: "/nsconnect/guide/install.webp", icon: ShieldCheck, title: "2 · Install it", text: "Open the downloaded file from the notification bar. If the phone asks, allow “Install from this source” (Chrome) — this is normal for company apps. Tap Install, then Open." },
  { img: "/nsconnect/guide/signin.webp", icon: LogIn, title: "3 · Sign in & allow notifications", text: "Use your @nexsecure.in email and your portal / webmail password. Tap Allow when asked for notifications so management messages reach you instantly." },
];

export const InstallGuide = () => {
  const [apk, setApk] = useState(null);
  useEffect(() => { api.get("/app/info").then((r) => setApk(r.data)).catch(() => {}); }, []);
  const dl = `${BACKEND}/api/connect/app/download`;
  return (
    <div className="h-full overflow-y-auto px-5 py-6 nxc-fade-in" data-testid="install-guide">
      <Link to="/connect" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200" data-testid="install-guide-back"><ArrowLeft size={16} /> Back to sign in</Link>
      <div className="flex items-center gap-3 mt-5 mb-2">
        <img src="/nsconnect/logo-512.png" alt="" className="w-12 h-12 rounded-full" />
        <div>
          <h1 className="nxc-display text-2xl font-bold leading-tight">How to install</h1>
          <div className="text-xs text-slate-400">NexSecure Connect · Android</div>
        </div>
      </div>
      <p className="text-sm text-slate-400 mb-6">Three steps, about two minutes. Only NexSecure Technologies staff accounts can sign in.</p>
      <ol className="space-y-4">
        {STEPS.map((s) => (
          <li key={s.title} className="nxc-card overflow-hidden" data-testid={`install-step-${s.title[0]}`}>
            <img src={s.img} alt="" className="w-full aspect-[2/1] object-cover object-center opacity-90" />
            <div className="p-4">
              <div className="flex items-center gap-2 font-semibold text-slate-100"><s.icon size={16} className="text-blue-400" /> {s.title}</div>
              <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{s.text}</p>
            </div>
          </li>
        ))}
      </ol>
      <div className="nxc-card p-4 mt-4 text-sm text-slate-400 space-y-2">
        <div className="flex items-center gap-2 text-slate-200 font-semibold"><Bell size={15} className="text-amber-300" /> Tips</div>
        <p className="flex gap-2"><CheckCircle2 size={15} className="text-emerald-400 shrink-0 mt-0.5" /> No Android phone? Open connect.nexsecure.in in Chrome and choose “Add to Home screen” — it works like the app.</p>
        <p className="flex gap-2"><CheckCircle2 size={15} className="text-emerald-400 shrink-0 mt-0.5" /> Forgot your password? It is the same as the Team Tracker / webmail password — contact HR to reset it.</p>
        <p className="flex gap-2"><CheckCircle2 size={15} className="text-emerald-400 shrink-0 mt-0.5" /> Updates are automatic — you never need to reinstall.</p>
      </div>
      {apk?.hosted ? (
        <a href={dl} className="nxc-btn nxc-btn-primary w-full h-12 mt-5" data-testid="install-guide-download"><Smartphone size={16} /> Download NexSecure Connect v{apk.version}</a>
      ) : (
        <p className="text-xs text-slate-500 mt-5 text-center">The Android app file is not published yet — HR will share it. You can use connect.nexsecure.in in the browser meanwhile.</p>
      )}
    </div>
  );
};
